<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="showForm && conclusion">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-filter</v-icon>
                <p style="color: white;">Filtro</p>

            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="8">
                            <center>
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Abogado:</span>
                                    <p style="font-size:18px" class="type-text-style">{{ prnombre }}</p>
                                </div>

                            </center>
                            <div class="mt-2">
                                <v-row>
                                    <v-col md="12">
                                        <v-radio-group v-model="datos.tipobusqueda">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-radio label="Buscar por Gerencia Actual" value="A"></v-radio>

                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-radio label="Buscar por Otra Gerencia" value="O"></v-radio>

                                                </v-col>
                                            </v-row>
                                        </v-radio-group>
                                    </v-col>

                                </v-row>
                            </div>


                            <div class="mt-2">
                                <span style="font-weight: bold;">Ingrese el nombre del abogado:</span>

                            </div>
                            <div class="button-container ">

                                <v-text-field class="align-left-button" v-model="datos.nombre"
                                    v-on:blur="datos.nombre = datos.nombre != null ? datos.nombre.trim() : null"
                                    outlined :rules="rulestext" maxlength="30" @keydown.enter.prevent="buscar()" dense>
                                </v-text-field>
                                <v-btn class="align-right-button" color="primary" max @click="buscar()">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>

                            </div>

                            <div v-if="showBusqueda">
                                <v-card-text>
                                    <v-row justify="center">
                                        <v-col cols="12">
                                            <DataTable :url="urlBusqueda" :columns="columnsBusqueda"
                                                :params="datosBusqueda" @apiDT="apiDT = $event"
                                                :formatterActions="formatterActions" :order="[[3, 'asc']]">
                                            </DataTable>



                                        </v-col>
                                    </v-row>



                                </v-card-text>

                            </div>



                        </v-col>

                    </v-row>



                </v-card-text>
            </v-form>
        </v-card>

        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-history</v-icon>
                <p style="color: white;">Historial Reasignaciones</p>

            </v-card-title>
            <v-form>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12">
                            <DataTable v-if="reloadtable" :url="urlHistorial" :columns="columns" :params="displayInputs"
                                @apiDT="apiDT = $event"></DataTable>



                        </v-col>
                    </v-row>



                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>




<script>
import reporteGeneral from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import DataTable from "@/components/pages/DataTableNet/DataTable";
export default {
    components: {
        DataTable
    },
    data() {
        return {
            conclusion: false,
            reloadtable: true,
            showForm: false,
            permisoReasignarSinCostoJur: false,
            permisoReasignarJuridico: false,
            permisoReasignarSinCosto: false,
            permisoReasignarRLV: false,
            permisoReasignarRCM: false,
            showBusqueda: false,
            validForm: true,
            prnombre: '',
            datos: {
                tipobusqueda: 'A',
                nombre: null,
                prclave: '',
            },
            datosBusqueda: {
                tipobusqueda: 'A',
                nombre: null,
                prclave: '',
            },
            rulestext: [
                v => {
                    if (v == null || v == '') {
                        return 'Ingrese el nombre del abogado'
                    }
                    else {
                        if (v.length < 3) {
                            return 'Mínimo 3 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            urlBusqueda: "ReporteGeneral/MostrarProveedorReasignacion",
            urlHistorial: "ReporteGeneral/HistorialReasignaciones",
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
                aiclave: 0
            },
            columnsBusqueda: [
                { name: 'prnombre', data: 'prnombre', title: "Nombre" },
                { name: 'susupervisoria', data: 'susupervisoria', title: "Supervisoría" },
                { name: 'genombre', data: 'genombre', title: "Gerencia" },
                { name: 'prestatus', data: 'prestatus', title: "Estatus" },
                { name: "asig", data: "asig", title: "", formatter: [this, "formatearAsignar"], orderable: false },
            ],
            formatterActions: [
                { click: [this, "asignarAbogado"] },

            ],
            columns: [
                { name: 'nrreporte', data: 'nrreporte', title: "Reporte" },
                { name: 'svindice', data: 'svindice', title: "Indice" },
                { name: 'refecha', data: 'refecha', title: "Fecha y hora de reasignación" },
                { name: 'prnombre', data: 'prnombre', title: "Nombre proveedor" },
                { name: 'uslogin', data: 'uslogin', title: "Login reasignó" },
            ],
            permisoReasignarCivil: false
        }
    },
    watch: {
        'datos.tipobusqueda'(val) {
            this.showBusqueda = false;
        },
    },
    computed: {
        ...mapState(["domain", "informationPage", "permission"]),
    },
    methods: {
        formatearAsignar(x) {
            if (!this.permisoReasignarSinCostoJur && x.prnombre.includes('SIN COSTO')) {
                return ``;
            }
            else {
                if (x.prestatus == 'ACTIVO') {
                    return `<button type="button" data-action="0" data-params="${x}" class="dt-formatterAction ma-2 v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default green" title="Asignar"><span class="v-btn__content"><span style="color: white;">Asignar</span></span></button>`;
                }
                else {
                    return ``;
                }
            }

        },
        async asignarAbogado(params, item, fila) {
            this.$swal({
                position: 'center',
                title: 'Reasignando Abogado ...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });
            await reporteGeneral.reasignarAbogado(this, item.prclave, item.prnombre).then(response => {

                setTimeout(() => {
                    this.$swal.close();
                    if (response) {
                        this.reloadtable = false;
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se reasignó el abogado correctamente',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.prnombre = item.prnombre;
                                this.datos.prclave = item.prclave;
                                this.datosBusqueda.prclave = item.prclave;
                                this.limpiar();
                            }
                        });
                        setTimeout(() => {
                            this.prnombre = item.prnombre;
                            this.datos.prclave = item.prclave;
                            this.datosBusqueda.prclave = item.prclave;
                            this.limpiar();
                            this.$swal.close();
                        }, 3000);

                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'Hubo un error al reasignar el abpgado, Favor de avisar a Desarrollo',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                    }

                }, 2000);
            });
        },
        limpiar() {
            this.datos.tipobusqueda = 'A';
            this.datos.nombre = null;

            this.datosBusqueda.tipobusqueda = 'A';
            this.datosBusqueda.nombre = null;

            this.reloadtable = true;
            this.showBusqueda = false;
            this.$refs.form.resetValidation();

        },
        buscar() {
            this.$refs.form.validate();
            if (this.$refs.form.validate()) {
                this.showBusqueda = true;

                const prclave = this.datos.prclave;
                const tipobusqueda = this.datos.tipobusqueda;
                const nombre = this.datos.nombre.trim();

                this.datosBusqueda.prclave = prclave;
                this.datosBusqueda.tipobusqueda = tipobusqueda;
                this.datosBusqueda.nombre = nombre;

            }



        },
    },
    async mounted() {
        let datosreporte = await MetodosGenerales.obtenerSessionReporte('reporte');

        this.displayInputs = {
            nrreporte: datosreporte.nrreporte,
            svindice: datosreporte.svindice,
            aiclave: datosreporte.aiclave,
        };
        let validaConc = await MetodosGenerales.getReporteEstatus(this);

        if (validaConc != 2) {
            this.conclusion = true;
        }

        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '95,85,167,86,105,374').then(response => {

            if (response.data.length > 0) { //si tiene el permiso

                response.data.forEach(object => {
                    if (object.peclave == 95)
                        this.permisoReasignarSinCostoJur = true; //reasignar_sincosto Jur
                    else if (object.peclave == 85)
                        this.permisoReasignarJuridico = true; //reasignar_juridico
                    else if (object.peclave == 167)
                        this.permisoReasignarSinCosto = true;//reasignar_sin_Costo
                    else if (object.peclave == 86)
                        this.permisoReasignarRLV = true;//reasignar_rlv
                    else if (object.peclave == 105)
                        this.permisoReasignarRCM = true;//reasignar_RCM
                    else if (object.peclave == 374)
                        this.permisoReasignarCivil = true;//reasignar Civil
                });
            }
        });


        await reporteGeneral.obtenerDatosReporte(this).then(response => {

            this.prnombre = response.data[0].prnombre;
            this.datos.prclave = response.data[0].prclave;

            if (this.displayInputs.aiclave == 1) { //juridica
                if (!this.permisoReasignarJuridico
                    || this.datos.prclave.includes('PEND')
                    || (!this.permisoReasignarSinCosto && this.prnombre.includes('SIN COSTO'))) {
                    this.showForm = false;
                }
                else {
                    this.showForm = true;
                }
            }
            else if (this.displayInputs.aiclave == 23) {//rlv


                if (!this.permisoReasignarRLV
                    || this.datos.prclave.includes('PEND')
                    || (!this.permisoReasignarSinCosto && this.prnombre.includes('SIN COSTO'))) {

                    this.showForm = false;
                }
                else {
                    this.showForm = true;
                }

            }
            else if (this.displayInputs.aiclave == 24) {//robo
                if (!this.permisoReasignarJuridico
                    || this.datos.prclave.includes('PEND')
                    || (!this.permisoReasignarSinCosto && this.prnombre.includes('SIN COSTO'))) {
                    this.showForm = false;
                }
                else {
                    this.showForm = true;
                }

            }
            else if (this.displayInputs.aiclave == 5) {//RCM

                if (!this.permisoReasignarRCM
                    || (!this.permisoReasignarSinCosto && this.prnombre.includes('SIN COSTO'))) {
                    this.showForm = false;
                }
                else {
                    this.showForm = true;
                }

            } else if (this.displayInputs.aiclave == 27) { //Civil
                if (!this.permisoReasignarCivil
                    || this.datos.prclave.includes('PEND')
                    || (!this.permisoReasignarSinCosto && this.prnombre.includes('SIN COSTO'))) {
                    this.showForm = false;
                }
                else {
                    this.showForm = true;
                }
            }




        });

    }
}
</script>

<style>
.button-container {
    display: flex;
}

.align-left-button {
    float: left;
    width: auto;
}

.align-right-button {
    float: left;
    width: 20px !important;
    height: 40px !important;
}
</style>
